<nav class="navbar navbar-expand-lg navbar-light fixed-top bg-light px-3 py-0">
  <a class="navbar-brand" routerLink="/" (click)="changeContent('search')" title="Go to homepage">
    <img src="../assets/logo_bubble.png" width="230" height="100%" alt="Logo">
  </a>
  <!-- <small class="badge badge-primary ms-2 me-1 mt-4">BETA</small> -->
  <button class="navbar-toggler" type="button"
    data-bs-toggle="collapse" data-bs-target="#navbar-supported-content"
    aria-controls="navbar-supported-content" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbar-supported-content">
    <ul class="navbar-nav me-auto">
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
            (click)="changeContent('search')">
            <i class="fa fa-search"></i> Search
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/stakeholders" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('stakeholders')">
            <i class="fa fa-globe"></i> Stakeholders
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/organizations" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('organizations')">
            <i class="fa fa-building"></i> Third parties
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/clients" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('clients')">
            <i class="fa fa-users"></i> Clients
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/team" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('team')">
            <i class="fa fa-heart"></i> Team
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/track-record" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('track-record')">
            <i class="fa fa-list"></i> Records
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/statistics" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('statistics')">
            <i class="fa fa-bar-chart"></i> Stats
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/pdf" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('pdf')">
            <i class="fa fa-file-pdf-o"></i> PDF
          </a>
        }
      </li>
      <li class="nav-item">
        @if (auth.loggedIn) {
          <a routerLink="/documents" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
            (click)="changeContent('documents')">
            <i class="fa fa-book"></i> Documents
          </a>
        }
      </li>
    </ul>
    <form class="d-none form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form>
    <div class="form-inline my-2 my-lg-0">
      <ul class="navbar-nav me-auto">
        <li class="nav-item">
          @if (!auth.loggedIn) {
            <a routerLink="/register" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
              (click)="changeContent('register')">
              <i class="fa fa-user-plus"></i> Register
            </a>
          }
        </li>
        <li class="nav-item">
          @if (!auth.loggedIn) {
            <a routerLink="/login" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
              (click)="changeContent('login')">
              <i class="fa fa-sign-in"></i> Login
            </a>
          }
        </li>
        <li class="nav-item" data-bs-toggle="tooltip" data-placement="bottom" data-delay="350" title="Admin panel">
          @if (auth.loggedIn && auth.isAdmin) {
            <a routerLink="/admin" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
              (click)="changeContent('logs')">
              <i class="fa fa-lock"></i> <span class="d-lg-none ms-1">Admin</span>
            </a>
          }
        </li>
        <li class="nav-item" data-bs-toggle="tooltip" data-placement="bottom" data-delay="350" title="Feedback">
          @if (auth.loggedIn) {
            <a routerLink="/feedback" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
              (click)="changeContent('feedback')">
              <i class="fa fa-commenting"></i> <span class="d-lg-none ms-1">Feedback</span>
            </a>
          }
        </li>
        <li class="nav-item" data-bs-toggle="tooltip" data-placement="bottom" data-delay="350" title="Notifications">
          @if (auth.loggedIn) {
            <a routerLink="/notifications" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
              (click)="changeContent('notifications')">
              <i class="fa fa-bell"></i> <span class="d-lg-none ms-1">Notifications</span>
              <small><sup class="badge ms-1" [ngClass]="{ 'badge-primary': !unreadCount, 'badge-danger': unreadCount }">{{unreadCount}}</sup></small>
            </a>
          }
        </li>
        <li class="nav-item">
          @if (auth.loggedIn) {
            <a routerLink="/account" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active"
              (click)="changeContent('account')">
              <i class="fa fa-user"></i> Account ({{auth.currentUser.firstName}})
            </a>
          }
        </li>
        <li class="nav-item">
          @if (auth.loggedIn) {
            <a routerLink="/logout" class="nav-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLinkActive="active">
              <i class="fa fa-sign-out"></i> Logout
            </a>
          }
        </li>
      </ul>
    </div>
  </div>
</nav>

<main class="container-fluid">
  <router-outlet></router-outlet>
</main>